// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_login__nRn4\\+ {
  min-width: 300px;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/login.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AACJ","sourcesContent":[".login{\n    min-width: 300px;\n    background-color: white;\n    padding: 20px;\n    border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login": `login_login__nRn4+`
};
export default ___CSS_LOADER_EXPORT___;
